import Cookies from 'js-cookie'
export const UserInfo = ['masterId', 'roleId', 'sessionId', 'storeId', 'userName', 'source']
import {useRouter, useRoute} from 'vue-router'
export function isEmptyObject(obj) {
    for(const item in obj) {
        return false
      }
      return true
}

export function setUserCookie(params) {
    if(!isEmptyObject(params || {})) {
      for (const key in params) {
        Cookies.set(key, (params[key] || ''), { path: '/', domain: window.top.location.hostname});
      }
   }
}

export function getUserCookie () {
    const userData = {};
    UserInfo.forEach(function(item){
      if (Cookies.get(item)) {
        userData[item] = Cookies.get(item, { path: '/', domain: window.top.location.hostname});
      }
    });
    return userData;
}

export function clearAllCookie () {
    const date = new Date();
    date.setTime(date.getTime()-10000);
    const keys = document.cookie.match(/[^ =;]+(?=)/g);
    if (keys) {
      for (let i = keys.length; i--;) {
           Cookies.remove(keys[i], { path: '/', domain: window.top.location.hostname});
          // Cookies.remove(keys[i], { path: '/', domain: window.top.location.hostname.replace('pc', '')});
       }
     }
   }

  
export class History {
  constructor() {
   this.platform = null
   
 }
 static _router = new History()
 static getInstance() {
   return this._router
 }
 getCrrentPath = (params) => {
  const { path, query} = useRoute()
   const publicPath = [
      {
      rootPath: '/angular',
      crrutPath: (url) => {
         return url.replace(/^(\/angular\/)/, '/') || url
      },
      testfn: (url) => {
        if(/^(\/angular\/)/.test(url)) {
            return true
        } else {
          return false
        }
      }
    }
  ]
 const opt = params ? publicPath.find(it => it.testfn(params.path)) : publicPath.find(it => it.testfn(path))
  return {...opt, query, path: opt.crrutPath(params?.path || path)} || {}
}
serialization = (querys, strPath) => {
   let strSn = strPath || ''
   if (typeof querys === "object" && !Array.isArray(querys) && Object.keys(querys).length) {
    for (const [key, value] of Object.entries(querys)) {
        if(key !== '$taroTimestamp' || key !== 'stamp') {
          if (strSn.indexOf('?') !== -1) {
              strSn += `&${key}=${value}`
          } else {
              strSn += `?${key}=${value}`
          }
        }
      }
   }
  
   return strSn
 }
 filterWxSceneQuery = (options) => {
   const queryParams = {}
    for(const [k, v] of Object.entries(options)) {
      if(k === 'scene' && v && typeof v === 'string') {
        const params = v ? (decodeURIComponent(v).includes('&') ? decodeURIComponent(v).split('&').filter(item => item) : decodeURIComponent(v).split(',').filter(item => item)) : []
              params.forEach(it => {
               const [key, value] = it.split('=').filter(its => its)
               queryParams[key] = value
            })
      } else {
         queryParams[k] = v
      }
    }
    const {stamp, $taroTimestamp, ..._queryParams } = queryParams
     return _queryParams
  }
  getfilterUrlParams(name) {
   let url = window.location.href;
   let temp1 = url.split('?');
   let obj = {};
   if(temp1.length > 1) {
     let pram = temp1[1];
     if(pram.split('&').length) {
       let keyValue = pram.split('&');
       for (let i = 0; i < keyValue.length; i++) {
           let item = keyValue[i].split('=');
           if(item.length > 1) {
             let key = item[0];
             let value = item[1];
             if(name !== key) {
               obj[key] = value;
             }
         }
      }
     }
   }

 return temp1[0] + this.serialization(obj);
}
getCurrentRouter() {
     const { query, path } = useRoute()
     return this.getQueryParams(query)
 }
 getQueryParams(params, url)    {
   let theRequest = new Object();
   if(params && Object.keys(params).length) {
      theRequest = params
   } else {
     if (!url)
     url = location.href;
       if (url.indexOf("?") !== -1)
       {
           const str = url.substr(url.indexOf("?") + 1) + "&";
           const strs = str.split("&");
           for (let i = 0; i < strs.length - 1; i++)
           {
               const key = strs[i].substring(0, strs[i].indexOf("="));
               const val = strs[i].substring(strs[i].indexOf("=") + 1);
               theRequest[key] = decodeURIComponent(val);
           }
       }
   }
   const _theRequest = this.filterWxSceneQuery(theRequest)
   return {query:_theRequest, path: window.location.pathname, fullPath: window.location.pathname + this.serialization(_theRequest)};
}
push({path, query = {}, ...options}) {
 const queryParams = this.serialization(query)
 const {type,  ..._options} = options
 if(/^http[s]?:\/\/.*/.test(path)) {
    window.location.href = `${path + queryParams}`
 } else {
    const router = useRouter()
    router.push({path, query, ...options})
 }
}
randomRange(min, max, charStr){
  /** 随机生成固定位数或者一定范围内的字符串数字组合
   * @param {Number} min 范围最小值
   * @param {Number} max 范围最大值，当不传递时表示生成指定位数的组合
   * @param {String} charStr指定的字符串中生成组合
   * @returns {String} 返回字符串结果
   *
   * */
let returnStr = "", range;
if(typeof min == 'undefined'){
  min = 5
}
if(typeof max == 'string'){
  charStr = max
}
range = ((max && typeof max == 'number') ? Math.round(Math.random() * (max-min)) + min : min)
charStr = charStr || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
for(let i=0; i < range; i++){
  let index = Math.round(Math.random() * (charStr.length-1))
  returnStr += charStr.substring(index, index+1)
}
return returnStr
}
goToBack(index, options) {
  
 }
 isWeixinBrowser(){
   var ua = navigator.userAgent.toLowerCase();
   return (/micromessenger/.test(ua)) ? true : false ;
  }
}
export const history = History.getInstance()